// import { ApolloClient, InMemoryCache } from '@apollo/client';

const windowLocation = typeof window !== 'undefined' ? window.location : undefined;

// Temp solution to see T3 UI/UX
export const IS_T3_WEBSITE = new URLSearchParams(windowLocation?.search).has('isdealer');

export const IS_TESTING_ENVIRONMENT =
  // running the code locally
  process.env.NODE_ENV === 'development' ||
  // test pages
  !!windowLocation?.hostname.startsWith('oneaudi-feature-app') ||
  // query parameter
  new URLSearchParams(windowLocation?.search).get('environment') === 'development' ||
  // on qa.audiusa.com only use staging ENV
  windowLocation?.hostname.includes('qa');
